import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Hook for navigating to modal routes using nested routes
 * Used throughout analytics pages for filter modals, customize columns, etc.
 */
export const useModalNavigation = () => {
  const navigate = useNavigate();

  const navigateToModal = useCallback(
    (path: string, additionalState?: Record<string, any>) => {
      navigate(path, {
        state: additionalState,
      });
    },
    [navigate]
  );

  return { navigateToModal };
};
